<span *ngIf="validationMessage" class="text-xs text-red-500 font-normal">
    {{validationMessage.message}}
</span>
